module.exports = __webpack_public_path__ + "img/logo-white.b773d4a.svg";